export function isTruthy(value: unknown): boolean {
  if (value === "true") return true;

  if (value === "false") return false;

  return !!value;
}
